<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" 
              :class="{active: activeTab === tab.label}" 
              @click="switchTab(tab)">
          {{ tab.label }}
        </span>
      </div>
      <!-- <button type="button" class="refresh-btn" @click="onRefresh">刷新</button> -->
    </div>

    <!-- 消息模版内容区 -->
    <div v-if="activeTab==='微信消息模版'" class="message-template-container">
      <div class="filter-box">  

        <!-- 洗衣开始提醒模版 -->
        <div class="filter-item">
          <div class="filter-title">洗衣开始提醒模版</div>
          <div class="filter-content">
            <img src="@/assets/laundry/下单成功通知.png" alt="洗衣开始提醒模版" class="template-image">
          </div>
        </div>

        <!-- 洗衣结束提醒模版 -->
        <div class="filter-item">
          <div class="filter-title">洗衣结束提醒模版</div>
          <div class="filter-content">
            <img src="@/assets/laundry/订单完成通知.png" alt="洗衣结束提醒模版" class="template-image">
          </div>
        </div>

        <!-- 取衣即将超时提醒模版 -->
        <div class="filter-item">
          <div class="filter-title">取衣即将超时提醒模版</div>
          <div class="filter-content">
            <img src="@/assets/laundry/即将超时通知.png" alt="取衣即将超时提醒模版" class="template-image">
          </div>
        </div>

        <!-- 取衣超时提醒模版 -->
        <div class="filter-item">
          <div class="filter-title">取衣超时提醒模版</div>
          <div class="filter-content">
            <img src="@/assets/laundry/账号封禁通知.png" alt="取衣超时提醒模版" class="template-image">
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LaundryPushNotification',

  data() {
    return {
      // 页面Tab
      tabs: [
        { label: '微信消息模版' }
      ],
      activeTab: '微信消息模版',
      loading: false
    };
  },

  methods: {
    // 切换Tab
    switchTab(tab) {
      this.activeTab = tab.label;
    },

    // 刷新页面
    onRefresh() {
      this.showMessage('页面已刷新', 'success');
    },

    // 消息提示
    showMessage(message, type = 'info') {
      alert(`${type.toUpperCase()}: ${message}`);
    }
  }
};
</script>

<style scoped>
/* 主容器 */
div {
  box-sizing: border-box;

}
/* div {
  box-sizing: border-box;
  overflow: hidden; 
} */

.refresh-btn {
  padding: 6px 16px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s;
}

.refresh-btn:hover {
  background: #45a049;
}

.refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 消息模版容器 */
.message-template-container {
  width: 100%;
  height: calc(100vh - 60px);
  overflow: auto;
  background: #f5f7fa;
}

.filter-box{
  display: flex;
  flex-direction: row;
  justify-content: center;
  width:100%;
  min-height:100%;
  background:#fff;
  padding:30px;
  border-radius:8px;
  margin:0;
}

.filter-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  width:25%;
  min-width:300px;
  height: 550px;
  margin:20px;
  padding:15px;
  background:#fafafa;
  border-radius:8px;
  box-shadow:0 2px 8px rgba(0,0,0,0.1);
}

.filter-title{
  display: flex;
  font-size:24px;
  font-weight:bold;
  margin-bottom:15px;
  color:#333;
}

.filter-content{
  width: 100%;
  height: 450px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius:8px;
  background:#fff;
  padding:15px;
  box-shadow:0 1px 4px rgba(0,0,0,0.05);
  overflow: hidden;
}

.template-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .filter-box {
    flex-wrap: wrap;
  }
  
  .filter-item {
    width: 45%;
    margin: 15px;
  }
}

@media (max-width: 768px) {
  .filter-item {
    width: 90%;
    margin: 15px auto;
  }
}
</style>